import Vue from 'vue';

const success = (context, icals) => {
  context.icals = icals;
  $('.cancel').removeClass('disabled');
  $('.confirm').removeClass('disabled');
  swal(context.$t('rentals.detail.modals.ical_deleted_success'), '', 'success');
};


const failed = (context, error) => {
  swal('Error', context.$t('rentals.detail.modals.something_went_wrong'), 'error');
};

export default (context, { icalId }) => Vue.$http.post('/delete-ical', { icalId }).then((response) => {
  if (response && response.status === 200) {
    success(context, response.data.icals);
  } else {
    failed(context, response);
  }
}).catch(((error) => {
  failed(context, error);
}));



// WEBPACK FOOTER //
// ./src/app/services/rental/deleteIcal.js